import { SuperListModel } from 'src/app/shared/models/superCompos/super-list-model';
import { formatNumber } from '@angular/common';
import { ContactDto, MailMeSearchDto } from 'src/app/shared/interfaces';

export class MailFromAPI {
  items: MailMeSearchDto[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}
import { MailFileDto, ServiceDto } from 'src/app/shared/interfaces';
import { Nature } from '../iCourrier/nature';
import { Projet } from '../iCourrier/projet';
import { MailDetails, MailDetailsLockedWriteDto, MailDetailsTakeOverDto } from './mail-details-dto.';
import { WorkflowIDocCoreErrorDTO } from 'src/app/shared/interfaces/workflows/workflow-idoc-core-error-dto.interface';
import { WorkflowInstance } from '../workflows/workflow-instance';
import { DigitalCentersVMDTO } from 'src/app/shared/interfaces/digital-centers/digital-centers-vm-dto.interface';
import { NatureCustomData } from '../iCourrier/custom-datas/nature-custom-data';
import { LastStatusTransition } from '../iCourrier/scans/last-status-transition';
import { EmailSender } from '../iCourrier/email/email-sender';
import { ExchangeEmail } from '../exchange/exchange';
export class Mail extends SuperListModel {
  public id: number;
  public idString?: string;
  public serviceProprietaireId?: number;
  public refExpediteur?: string;
  public dateEntree?: string;
  public dateDocument?: string;
  public dateEcheance?: string;
  public datePostale?: string;
  public dateEncodage?: string;
  public expediteurId?: number;
  public expediteurIdiAdmin?: number;
  public expediteurLibre?: string;
  public nature?: Nature;
  public natureId?: number;
  public sourceId?: number;
  public source?: string;
  public classementId?: number;
  public classementCode?: string;
  public classeurId?: number;
  public classeurDescription?: string;
  public chemiseId?: number;
  public chemiseDescription?: string;
  public boiteArchive?: string;
  public serviceProprietaire?: ServiceDto;
  public remarques?: string;
  public confidentiel?: boolean;
  public objet?: string;
  public typeEntrantSortant?: string;
  public contactId?: number;
  public projet?: Projet;
  public projetId?: number;
  public statutId?: number;
  public refRecommande?: string;
  public avalider?: boolean;
  public aCompleter?: boolean;
  public lastStatusTransitionId?: number;
  public lastStatusTransition: LastStatusTransition;
  public expediteur?: string;
  public expediteurFull?: ContactDto;
  public asRead?: boolean;
  public icon: string;
  public statusGlobalName?: string;
  public statusGlobalColor?: string;
  public statusGlobalBackground?: string;
  public referenceRecommande?: string;
  public pinned?: boolean;
  public writeLockId?: number;
  public writeLock: MailDetailsLockedWriteDto;
  public mauvaisRoutage: boolean;
  public mauvaisRoutageCommentaires: string;
  public priseEnChargeInfo: MailDetailsTakeOverDto;
  public filesToValidate: Array<MailFileDto> = [];
  public filesToSign: Array<MailFileDto> = [];
  public token: string;
  public supprime: boolean;
  public validationEtape: number;
  public validationEtapeMax: number;
  public validationEtapeUserIds: Array<number> = [];
  public validationUsers: string;
  public workflowStartFailed: boolean;
  public workflowStartError: WorkflowIDocCoreErrorDTO;
  public workflowStartDefinitionId: string;
  public bacId: number;
  public annexeDiffusee: boolean;
  public annexeNonScannee: boolean;
  public annexeNonScanneeNombre: number;
  public bacLabelForInfos?: string;
  public workflowId?: string;
  public workflowForInfos?: WorkflowInstance;

  public classement?;
  public classementLabel?: string;
  public classeur?;
  public classeurLabel?: string;
  public chemise?;
  public chemiseLabel?: string;
  public natureCustomDatas?: NatureCustomData[] = [];
  public version?;
  public centreNumerisation?: DigitalCentersVMDTO;
  public centreNumerisationId?: number;
  public statusObjet?: {
    name?: string;
    background?: string;
    color?: string;
  };

  emailObject: ExchangeEmail;
  expediteurEmail: string;
  sender: EmailSender;
  subject?: string;
  date?: string;

  [key: string]: unknown;
  // Fields for SuperList

  constructor(data?) {
    super();
    Object.assign(this, data);
    if (this.objet) {
      this.setTitle(this.objet);
    } else {
      this.setTitle('Courrier sans objet');
    }
    if (this.objet) {
      this.setDescription(this.objet);
    }
    if (this.id) {
      const id = this.id;
      this.idString = formatNumber(id, 'es');
    }

    this.setDate(this.dateEntree);
    this.setIcon(this.typeEntrantSortant);
    this.setOrder(this.classementId);

    if (this.serviceProprietaire && this.serviceProprietaire.description) {
      this.setExpGroup(this.serviceProprietaire.description);
    }

    if (this.nature && this.nature.description) {
      this.setCategory(this.nature.description);
    }

    if (this.expediteur) {
      this.setExpTitle(this.expediteur);
    }

    this.setStatusColorClass();

    if (this.natureCustomDatas.length > 0) {
      this.natureCustomDatas.forEach((x) => {
        this['natureCustomFieldId' + x.natureCustomFieldId] = x.natureCustomFieldId;
      });
    }
  }
}

export class MailInfosViaExtraStateRouter {
  isAnswerMode?: boolean;
  isNew?: boolean;
  mailMode?: string;
  mailType?: string;
  mailId?: number;
  origin?: string;
  mail?: Partial<MailDetails>;
  expediteurId?: number;
  expediteurIdiAdmin?: number;
}
